import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StrmClassVideo } from "shared/interfaces/StrmClassVideo";
import { fetchStrmClassVideos } from "shared/service/StrmService";

export const getStrmClassVideos = createAsyncThunk(
  "strm-class/GetVideos",
  async () => {
    const videos: any = await fetchStrmClassVideos();
    return videos;
  }
);

export type StrmClassState = {
  strmClass: {
    videos: StrmClassVideo[];
    loading: boolean;
  };
};

export const usersSlice: any = createSlice({
  name: "strm-class",
  initialState: {
    videos: [],
    loading: false,
  },
  reducers: {},
  extraReducers: {
    [getStrmClassVideos.fulfilled.type]: (state, action) => {
      state.videos = action.payload;
      state.loading = false;
    },
    [getStrmClassVideos.pending.type]: (state) => {
      state.loading = true;
    },
  },
});

export default usersSlice.reducer;
